import { Injector } from "@angular/core";
import { RequestAddOnPayload, ClientSocketEvent, RequestRebuyPayload, RequestRefuseRebuyPayload } from "@soposopo/sopo-models/dist";
import { GameStateId } from "../../state/game/game.state";
import { TournamentGameServer } from "./base/tournament-game-server.class";


export class MttGameServer extends TournamentGameServer {

    constructor(
        protected url: string, protected gameStateId: GameStateId, protected injector: Injector
    ) {
        super();
        this.init();
    }

    protected injectServices() {
        super.injectServices();
    }

    listenToMessages() {
        super.listenToMessages();
    }
    
    async requestAddOn(tableID: any,userID: string) {
        const payload: RequestAddOnPayload = { tableID, userID};
        this.socket.emit(ClientSocketEvent.ADDON_USED, payload);
    }

    async requestRebuy(tableID: any,userID: string) {
        const payload: RequestRebuyPayload = { tableID, userID};
        this.socket.emit(ClientSocketEvent.REBUY_USED, payload);
    }

    async requestRefuseRebuy(tableID: any,userID: string) {
        const payload: RequestRefuseRebuyPayload = { tableID, userID};
        this.socket.emit(ClientSocketEvent.REBUY_REFUSED, payload);
    }

    protected stopListeningToMessages() {
        super.stopListeningToMessages();
    }
}
